import { Box, Button, Chip, makeStyles } from "@material-ui/core";
import { TextArea, TextBox } from "devextreme-react";
import React, { useState } from "react"
import { EmailCodeTemplates } from "../../../Constantes/emailCodeTemplates";
import { SmsFormTypes } from "../../../Constantes/smsFormTypes";
import { useDispatch, useSelector } from "react-redux";
import { selectWorkshopTypes } from "../../../redux/workshopTypes/selectors";
import { baseRequest } from "../../../fetch/basicThunk";
import { QUERY_GET_ITVS_BY_POSTAL_CODE, QUERY_GET_PROVINCE_BY_POSTALCODE } from "../../../fetch/constantQueries";
import { openModal } from "../../../redux/modal/modalSlice";
import DateBox from "../../common/CustomDateBox"
import SelectBox from "../../common/CustomSelectBox"
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { Attachment } from "@material-ui/icons";

const useStyles = makeStyles({
        label: {
            color: "#eeeeee"
        },
        controlers: {
            width:"100% !important"
        },
        hideSmsContainer: {
            display:"none"
        },
        input_grid: {
            display: "grid",
            columnGap: 10,
            gridTemplateColumns: "1fr 1fr",
            marginBottom:10,
        },
        gridTwo:{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            columnGap: "1rem",
            rowGap: "1rem"
        }
});

function EmailForm(props){
    const { t } = useTranslation();
    const classes = useStyles();
    const {dataForm, handleChangeEmailForm, formType, workshopSearch} = props;
    const workshopTypes = useSelector(selectWorkshopTypes).workshopTypes;
    const [stations, setStations] = useState([])
    const dispatch = useDispatch();
    const templateCode = dataForm.template?.templateCode;

    async function setProvince(){
        if(!dataForm?.postalCode || dataForm?.postalCode.length < 5 ){
            handleChangeEmailForm("province", null); 
            handleChangeEmailForm("stationId", null);
            return
        }
    
        const province = await fetchProvinceFromPostalCode(dataForm?.postalCode);
        
        if(province){
            const provinceHasNewValue = province.name !== dataForm?.province
            if(provinceHasNewValue){
                handleChangeEmailForm("stationId", null)
            }
            handleChangeEmailForm("province", province.name)
            fetchStations(dataForm?.postalCode)
        } else {
            handleChangeEmailForm("stationId", null)
        }
    }

    async function fetchProvinceFromPostalCode(postalCode){
        let province;
        try {
            province = await baseRequest({param: postalCode }, dispatch, QUERY_GET_PROVINCE_BY_POSTALCODE, "GET");
        } catch (error) {
            province = null
            handleChangeEmailForm("province", null)
            setStations([])
        }    
        return province
    }

    async function fetchStations(postalCode){

        try {
            const stations = await baseRequest({param: postalCode }, dispatch, QUERY_GET_ITVS_BY_POSTAL_CODE, "GET")
            if(stations){
                setStations(stations)
            }
        } catch (error) {
            dispatch(openModal({type: "error", message: "No se han podido cargar las ITVs"}))
        }
    }


    return (<>
                <div style={{display: "flex", flexDirection: "column", rowGap: "1rem", marginTop: "1rem", maxHeight: "calc(100vh - 24rem)", overflowY: "auto"}}>
                    <div style={{display: "flex", alignItems: "space-between", columnGap: "1rem"}}>
                        <div style={{flex: "1 1 0"}}>
                             <SelectBox label={t("template")} labelMode="floating" value={dataForm.template} displayExpr="name" onValueChange={props.handleTemplateChange} placeholder="" dataSource={props.templates}></SelectBox>
                        </div>
                        {formType !== SmsFormTypes.email &&
                        <div style={{flex: "1 1 0"}}>
                            <TextBox label={"Asunto"} labelMode="floating" maxLength={100} valueChangeEvent="keyup" onValueChanged={(e)=>handleChangeEmailForm("subject" , e.value)} value={dataForm.subject} className={classes.controlers} ></TextBox>
                        </div>  
                        } 
                    </div>
                    {(templateCode == EmailCodeTemplates.APPOINTMENT_CONFIRMATION || templateCode == EmailCodeTemplates.WORKSHOP_INFO) &&
                    <>
                        <div className={classes.gridTwo}>
                                    { workshopSearch == undefined || workshopSearch.length == 0?
                                    <TextBox label={"Taller"} labelMode="floating" value={dataForm.workshopId} onValueChange={(e)=>handleChangeEmailForm("workshopId",e)} placeholder="Id del taller" maxLength={25} valueChangeEvent="keyup" className={classes.controlers} ></TextBox>
                                    :<SelectBox label={"Taller"} labelMode="floating" value={dataForm.workshopId} valueExpr="workshopId" displayExpr="name" onValueChange={(e)=>handleChangeEmailForm("workshopId",e)} placeholder="" dataSource={workshopSearch} ></SelectBox> }
                                    <SelectBox label={t("Type")} labelMode="floating" disabled={workshopSearch != undefined || workshopSearch?.length > 0} value={dataForm.workshopType} valueExpr="workshopTypeId" displayExpr="workshopType" onValueChange={(e)=>handleChangeEmailForm("workshopType",e)} dataSource={workshopTypes} ></SelectBox>
                        </div>
                        {templateCode === EmailCodeTemplates.APPOINTMENT_CONFIRMATION &&
                            <div>
                                        <DateBox
                                        type="datetime"
                                        label="Fecha de cita"
                                        labelMode="floating"
                                        className={classes.controlers}    
                                        value={dataForm.appointmentDate}
                                        min={new Date().toISOString().slice(0, 10)}
                                        showClearButton={true}
                                        useMaskBehavior={true}
                                        acceptCustomValue={false}
                                        displayFormat="dd/MM/yyyy HH:mm"
                                        applyButtonText="Aceptar"
                                        cancelButtonText="Cancelar"
                                        onValueChanged={(e)=>handleChangeEmailForm("appointmentDate",e.value)} />
                            </div>}
                    </>}
                    {
                        templateCode == EmailCodeTemplates.ITV_APPOINTMENT &&
                        <div className={classes.gridTwo}>
                            <TextBox label="Código postal" labelMode="floating" maxLength={5} key={"postalCode"} name="postalCode" value={dataForm?.postalCode} onFocusOut={()=>setProvince()}  onValueChanged={(e) => handleChangeEmailForm("postalCode", e.value)} className={classes.controlers} ></TextBox>
                            <TextBox label="Provincia" labelMode="floating" disabled key={"province"} name="province" value={dataForm?.province} className={classes.controlers} ></TextBox>
                            <SelectBox label="Estación" labelMode="floating" value={dataForm?.stationId} valueExpr={"id"} 
                                placeholder={""}
                                disabled={!dataForm?.province}
                                searchEnabled
                                onValueChanged={(e) =>handleChangeEmailForm("stationId",e.value)} 
                                itemRender={(item)=><div style={{whiteSpace: "normal"}} className={classes.custom_item}> <span style={{fontWeight: "bold"}}>{item && `${item.city}`}</span>{item? `, ${item?.address ? item.address : ""} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""}</div>}
                                displayExpr={(item)=> item? `${item?.city}, ${item?.address} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""} 
                                dataSource={stations}  
                                noDataText={"No hay opciones disponibles"}>
                            </SelectBox>
                            <DateBox label="Fecha y hora" labelMode="floating" applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"date"} name="date" type="datetime" value={dataForm?.appointmentDate} onValueChanged={(e) => handleChangeEmailForm("appointmentDate", e.value)} className={classes.controlers} ></DateBox>
                            
                        </div>
                    }
                    {( dataForm.template!=null && (dataForm.template.templateCode == EmailCodeTemplates.MARSH_ERROR))  &&
                        <div>
                            <>  
                                
                                    <TextBox label="Nome" labelMode="floating" key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => handleChangeEmailForm("name",e.value)} className={classes.controlers} ></TextBox>
                                
                                
                                    <TextBox label="Apellidos" labelMode="floating" key={"surname"} name="surname" value={dataForm?.surnames} onValueChanged={(e) => handleChangeEmailForm("surnames",e.value)} className={classes.controlers} ></TextBox>
                                
                            </>
                            <>  
                                
                                    <TextBox label="Móvil" labelMode="floating" key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{handleChangeEmailForm("phoneNumber" , e.value)}} className={classes.controlers} ></TextBox>
                                 
                            </>
                        </div>
                    }
                    <>
                        <TextArea label={t("Recipients")} labelMode="floating" maxLength={1000} valueChangeEvent="keyup" onValueChanged={(e)=>handleChangeEmailForm("email" , e.value)} value={dataForm.email} className={classes.controlers} height={120}></TextArea>
                        {/* {formType !== SmsFormTypes.email_customer &&
                        <> */}
                        <TextArea label={"CC"} labelMode="floating" maxLength={500} valueChangeEvent="keyup" onValueChanged={(e)=>handleChangeEmailForm("cc" , e.value)} value={dataForm.cc} className={classes.controlers} height={120}></TextArea>   
                        <TextArea label={t("Comments")} labelMode="floating" key={"contentEmail"} name="contentEmail" value={dataForm?.contentEmail} onValueChanged={(e) => handleChangeEmailForm("contentEmail" , e.value)} className={classes.controlers} height={120}></TextArea>

                        <Button
                            component="label"
                            variant="text"
                            size="small"
                            startIcon={<Attachment sx={{ fontSize: '1rem' }} />}
                            sx={{ textTransform: 'none', color: '#555555', fontSize: '0.75rem', fontWeight: 600, py: 0.2, }}
                            >
                            Anexar Arquivo
                            <input type="file" multiple hidden onChange={(e) => handleChangeEmailForm('attachments', e.target.files)} />
                        </Button>
                        {dataForm?.attachments?.length > 0 && (
                            <Box style={{width: "100%"}} sx={{ display: 'flex', flexWrap: 'wrap', gap: ".4rem", padding: ".4rem", borderTop: '1px solid black' }}>
                            {dataForm?.attachments.map((file, idx) => (
                                <Chip
                                key={idx}
                                label={`${file.nameMin} (${file.size})`}
                                title={file.name}
                                //onDelete={() => removeCommentAttachment(idx)}
                                size="small"
                                icon={<Attachment sx={{ fontSize: '0.75rem !important' }} />}
                                sx={{ borderRadius: '2px', bgcolor: '#275aa7', height: 22, fontSize: '0.7rem', fontWeight: 600 }}
                                />
                            ))}
                            </Box>
                        )}
                            
                        {/* </>} */}
                    </>
            </div>
    </>)
}

export {EmailForm}